/**
 * Hook for managing calendar display state
 */

import { useState } from 'react';
import type { CalendarDisplayState } from '../types/DurationTypes';

export const useCalendarDisplay = (
  initialStartDisplayDate: Date,
  initialEndDisplayDate: Date
) => {
  const [startDisplayDate, setStartDisplayDate] = useState(initialStartDisplayDate);
  const [endDisplayDate, setEndDisplayDate] = useState(initialEndDisplayDate);

  const navigateCalendar = (calendar: 'start' | 'end', direction: 'prev' | 'next') => {
    const setDate = calendar === 'start' ? setStartDisplayDate : setEndDisplayDate;
    
    setDate(prev => {
      const newDate = new Date(prev);
      if (direction === 'next') {
        newDate.setMonth(newDate.getMonth() + 1);
      } else {
        newDate.setMonth(newDate.getMonth() - 1);
      }
      return newDate;
    });
  };

  const updateDisplayDatesFromSelection = (selectedDate: Date, isStartDate: boolean) => {
    if (isStartDate) {
      // Update start display to show the month of selected date
      setStartDisplayDate(new Date(
        selectedDate.getFullYear(), 
        selectedDate.getMonth(), 
        1
      ));
    } else {
      // Update end display to show the month of selected date
      setEndDisplayDate(new Date(
        selectedDate.getFullYear(), 
        selectedDate.getMonth(), 
        1
      ));
    }
  };

  const syncEndDisplayToStart = (startDate: Date) => {
    // Help users select consecutive days by syncing end calendar to start month
    setEndDisplayDate(new Date(startDate.getFullYear(), startDate.getMonth(), 1));
  };

  return {
    startDisplayDate,
    endDisplayDate,
    setStartDisplayDate,
    setEndDisplayDate,
    navigateCalendar,
    updateDisplayDatesFromSelection,
    syncEndDisplayToStart
  };
};